const AUTH_STORAGE_PREFIX='sb-'

export function isAuthStorageKey(key:string):boolean{
  return key.startsWith(AUTH_STORAGE_PREFIX)
}
